module.exports = __webpack_public_path__ + "static/media/Founders Legacy Society.eb3635a5.png";